import script from "./TimerWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TimerWidget.vue?vue&type=script&setup=true&lang=js"

import "./TimerWidget.vue?vue&type=style&index=0&id=47dd856e&lang=css"

const __exports__ = script;

export default __exports__